import React from 'react';
import { stores } from '../../../stores';
import { useStore } from '../../../hooks/useStore';

export const withLoggedIn = (Component) => (props) => {
    const [isAuthenticated] = useStore(stores.isAuthenticated);

    return isAuthenticated ? <Component {...props}>{props.children}</Component> : null;
};
